import { SharedCommonUtility } from './common.utility';

export class HmacUtility {
  public static MIN_SECRET_LENGTH: number = 32;
  public static MAX_HEADER_VALUE_LENGTH: number = 8000;

  public static readonly headerValidationRegex: string = '^[a-zA-Z0-9-_.]+$';

  /**
   * Returns whether or not HMAC secret is valid
   *
   * @param secret HMAC secret
   */
  public static isHmacSecretValid(secret: string): boolean {
    const hasUppercase = new RegExp('[A-Z]').test(secret);
    const hasLowercase = new RegExp('[a-z]').test(secret);
    const hasNumber = new RegExp('[0-9]').test(secret);
    const hasSpecialChar = new RegExp('[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>/?]').test(secret);

    if (
      SharedCommonUtility.isNullishOrEmpty(secret) ||
      secret.length < this.MIN_SECRET_LENGTH ||
      !hasUppercase ||
      !hasLowercase ||
      !hasNumber ||
      !hasSpecialChar
    ) {
      return false;
    }
    return true;
  }

  /**
   * Returns whether or not HMAC custom header names are valid
   *
   * @param headerName header name
   */
  public static isHeaderNameValid(name: string): boolean {
    if (SharedCommonUtility.isNullishOrEmpty(name) || !new RegExp(HmacUtility.headerValidationRegex).test(name)) {
      return false;
    }
    return true;
  }

  /**
   * Returns whether or not HMAC custom header values are valid
   *
   * @param value header value
   */
  public static isHeaderValueValid(value: string): boolean {
    if (SharedCommonUtility.isNullishOrEmpty(value)) {
      return false;
    }

    if (value.length > this.MAX_HEADER_VALUE_LENGTH) {
      return false;
    }

    const invalidCharacters: string[] = ['\r', '\n', '\x7F', '\0'];

    for (const invalidCharacter of invalidCharacters) {
      if (value.includes(invalidCharacter)) {
        return false;
      }
    }

    // Check for valid characters (printable ASCII + tab)
    if (!new RegExp('^[\x20-\x7E\t]*$').test(value)) {
      return false;
    }
    return true;
  }
}
